import actions, { actionInterface } from './actions';
import MODAL_MODE from '../../../../../pages/data/common/constants';
import { ExtensionTimelineEntry } from '../../../../../common/types/timeline/ExtensionPeriodEntryType';

export interface initialStateInterface {
  modalOpen: boolean;
  modalMode: MODAL_MODE;
  currentExtensionPeriod: ExtensionTimelineEntry;
}

const initialState: initialStateInterface = {
  modalOpen: false,
  modalMode: MODAL_MODE.create,
  currentExtensionPeriod: null,
}

const reducers = (state = initialState, action: actionInterface): initialStateInterface => {
  switch (action.type) {
    case actions.OPEN_EXTENSION_MODAL:
    case actions.CLOSE_EXTENSION_MODAL:
    case actions.SET_CURRENT_EXTENSION_PERIOD:
      return { ...state, ...action.payload }
    default:
      return state;
  }
}

export default reducers;
